import { RootState } from 'src/store';

import { IUser } from './types';

export const selectUsersListData = (state: RootState): IUser[] => state.users.list.data;
export const selectUsersLoading = (state: RootState): boolean => state.users.list.isLoading;
export const selectUsersLoaded = (state: RootState): boolean => state.users.list.isLoaded;
export const selectUserData = (state: RootState): IUser => state.users.item.data;
export const selectUserLoading = (state: RootState): boolean => state.users.item.isLoading;
export const selectUserLoaded = (state: RootState): boolean => state.users.item.isLoaded;
